import React from 'react';
import { PopoutMenu } from './PopoutMenu';
import { PopoutMenuFooter } from './PopoutMenuFooter';
import { PopoutMenuHeader } from './PopoutMenuHeader';

type Props = {
  isPopup: boolean;
  isOpen: boolean;
  isSubmitting?: boolean;
  position: 'left' | 'right';
  hdrTitle: string;
  primaryBtnTxt?: string;
  secondaryBtnTxt?: string;
  givenClass?: string;
  noFooter?: boolean;
  primaryBtnColor?: string;
  handleClose: any;
  handlePrimaryBtn?: any;
  handleSecondaryBtn?: any;
  width?: number;
  minWidth?: number;
  mobileMenu?: boolean;
  zIndexVal?: number;
  children?: any;
};

export const PopupOrPanel: React.FC<Props> = ({
  isPopup,
  isOpen,
  isSubmitting,
  position,
  hdrTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  givenClass,
  noFooter,
  primaryBtnColor,
  handleClose,
  handlePrimaryBtn,
  handleSecondaryBtn,
  width,
  minWidth,
  mobileMenu,
  zIndexVal,
  children,
}) => {
  let handCLoseFunc = () => {
    document.body.style.overflowY = '';
    handleClose();
  };

  let primaryBtnFunc = () => {
    if(primaryBtnTxt && (primaryBtnTxt?.toLowerCase() === "close" || primaryBtnTxt?.toLowerCase() === "cancel")){
      document.body.style.overflowY = '';
    }

    handlePrimaryBtn();
  };

  let secondaryBtnFunc = () => {
    if(secondaryBtnTxt && (secondaryBtnTxt?.toLowerCase() === "close" || secondaryBtnTxt?.toLowerCase() === "cancel")){
      document.body.style.overflowY = '';
    }

    handleSecondaryBtn();
  };    

  return (
    <PopoutMenu
      isPopup={isPopup}
      isOpen={isOpen}
      handleClose={handCLoseFunc}
      className={givenClass && givenClass}
      position={position}
      width={width}
      minWidth={minWidth}
      mobileMenu={mobileMenu}
      zIndexVal={zIndexVal}
    >
      <PopoutMenuHeader handleClose={handCLoseFunc} title={hdrTitle} />

      <div className="PopoutMenuContent">{children}</div>

      {!noFooter &&
        <PopoutMenuFooter
          primaryButtonText={primaryBtnTxt && primaryBtnTxt}
          secondaryButtonText={secondaryBtnTxt && secondaryBtnTxt}
          handlePrimaryButtonClick={handlePrimaryBtn && primaryBtnFunc}
          handleSecondaryButtonClick={handleSecondaryBtn && secondaryBtnFunc}
          primaryBtnColor={primaryBtnColor}
          isSubmitting={isSubmitting ?? false}
        />      
      }
    </PopoutMenu>
  );
};
